<template>
    <div class="c-dropdown" :class="dropdownClasses" @click="toggle" v-click-outside="close">
        <div ref="handle" class="c-dropdown__handle">
            <slot name="handle">
                Actions
            </slot>
        </div>
        <div ref="actions" class="c-dropdown__hidden" :class="{'hidden': !isOpen}">
            <ul class="c-dropdown__content">
                <slot></slot>
            </ul>
        </div>
    </div>
</template>
<script>
import Popper from 'popper.js';

export default {
    props: {
        constrain: {
            type: [String, HTMLElement],
            default: () => document.body,
        },

        offset: {
            type: [Number, String],
            default: '0, 8',
        },

        placement: {
            type: String,
            default: 'bottom-end',
        },
    },

    data() {
        return {
            isOpen: false,
            actualPlacement: this.placement,
        };
    },

    computed: {
        dropdownClasses() {
            let classes = [];
            classes.push(`c-dropdown--placement-${this.actualPlacement}`);
            if (this.isOpen) {
                classes.push('c-dropdown--open');
            }

            return classes;
        },
    },

    methods: {
        close() {
            // We don't have to do anything if we aren't open (of course)
            if (!this.isOpen) {
                return;
            }

            // Remove the listener for clicking on a menu item causing it to close
            if (this.$refs.actions) {
                this.$refs.actions.querySelectorAll('.c-dropdown__link').forEach(link => {
                    link.removeEventListener('click', this.close);
                });
            }

            this.isOpen = false;
        },

        open() {
            if (this.isOpen) {
                return;
            }

            // Show the menu and position it
            this.isOpen = true;
            this.$nextTick(() => {
                this.setupPopper();

                // Clicking on a menu item causes the menu to close
                if (this.$refs.actions) {
                    this.$refs.actions.querySelectorAll('.c-dropdown__link').forEach(link => {
                        link.addEventListener('click', this.close);
                    });
                }
            });
        },

        setupPopper() {
            // Don't need to specify this in the data property since we don't need it to be reactive
            if (this.popper === undefined) {
                this.popper = new Popper(this.$refs.handle.firstChild, this.$refs.actions, {
                    placement: this.placement,
                    modifiers: {
                        offset: {
                            enabled: true,
                            offset: this.offset,
                        },
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: document.body,
                        },
                    },
                    onCreate: this.updatePlacement,
                    onUpdate: this.updatePlacement,
                });
            } else {
                this.popper.scheduleUpdate();
            }
        },

        updatePlacement(data) {
            this.actualPlacement = data.placement;
        },

        toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },
    },

    beforeDestroy() {
        if (this.popper !== undefined) {
            this.popper.destroy();
        }
    },
};
</script>
